/**
 * Palette di marca, per tutto cio' che non passa dalle classi Tailwind:
 * PDF generati con jsPDF (che vuole terne RGB numeriche), stili inline dentro
 * i template email, e gli export in HTML.
 *
 * Il rosso e' campionato dal logo SLAB: #BA272D, cioe' hsl(357.6 65.3% 44.1%).
 * La scala 50-950 e' costruita sulla stessa tonalita'.
 *
 * ATTENZIONE: la stessa scala e' ripetuta in `tailwind.config.js` sotto
 * `colors.primary`, perche' Tailwind genera le classi a build-time e non puo'
 * importare questo modulo. Se cambi un valore qui, cambialo anche la'.
 * `scripts/refactor-checks.sh` confronta i due file e fallisce se divergono.
 *
 * Nota sul rosso: il rosso di marca e' volutamente piu' scuro e meno saturo
 * del rosso di errore di Tailwind (#DC2626). Servono a due cose diverse —
 * marca contro pericolo — e vanno restare distinguibili a colpo d'occhio.
 */

export const BRAND_COLORS = {
  50: '#FDF2F2',
  100: '#FBE5E6',
  200: '#F5C7C9',
  300: '#EDA1A4',
  400: '#DE5E63',
  500: '#D4353B',
  600: '#BA272D',
  700: '#9E1F24',
  800: '#85191E',
  900: '#6E171A',
  950: '#410B0E'
} as const;

/** Colore di marca principale. */
export const BRAND_PRIMARY = BRAND_COLORS[600];
/** Variante scura, per gradienti e testi su fondo chiaro. */
export const BRAND_PRIMARY_DARK = BRAND_COLORS[700];

/**
 * Colori secondari del logo SLAB (oro e verde).
 * Restano confinati al logo e al menu laterale: promuoverli a colori di
 * interfaccia li farebbe confondere con il giallo di avviso e il verde di
 * conferma, che nell'app hanno gia' un significato preciso.
 */
export const BRAND_GOLD = '#E1AF3C';
export const BRAND_GREEN = '#369750';

/** Converte "#BA272D" nella terna [186, 39, 45] che vuole jsPDF. */
const toRgb = (hex: string): [number, number, number] => [
  parseInt(hex.slice(1, 3), 16),
  parseInt(hex.slice(3, 5), 16),
  parseInt(hex.slice(5, 7), 16)
];

/** Terne RGB per jsPDF: linee, riempimenti e testi delle carte intestate. */
export const BRAND_RGB = toRgb(BRAND_COLORS[600]);
export const BRAND_LIGHT_RGB = toRgb(BRAND_COLORS[50]);
export const BRAND_BORDER_RGB = toRgb(BRAND_COLORS[200]);
export const BRAND_DARK_RGB = toRgb(BRAND_COLORS[800]);
